module.exports = __webpack_public_path__ + "static/media/githubl.4c7d03ca.png";